module.exports = __webpack_public_path__ + "static/img/hdw6.3f8c8083.jpg";